import ImageWidgetView from './ImageWidgetView.vue';

export const type = 'image';
export const view = ImageWidgetView;

export function builder() {
  return {
    type,
    left: 0,
    top: 0,
    rotate: 0,
    height: 200,
    width: 300,
    url: 'https://picsum.photos/200/300',
  };
}
